import React from 'react';

const ChatbotPage = () => (
  <div
    style={{
      width: '100%',
      height: 'calc(100vh - 80px)', // adjust based on your header/footer
      overflow: 'hidden',
      padding: '10px',
    }}
  >
    <iframe
      src="https://isir.ai/chatbot/?embedded=1"
      title="Chatbot"
      style={{
        width: '100%',
        height: '100%',
        border: '2px solid #7303fc', // highlight the iframe boundary
        borderRadius: '10px',
        backgroundColor: 'white',
      }}
    />
  </div>
);

export default ChatbotPage;
